/**
 * Component Entry
 *
 */

import GlobalStatus from './GlobalStatus'
export default GlobalStatus
export * from './GlobalStatus'
